import Vue from "vue";
import devices from "./devices";
import featureToggling from "./feature-toggling";

const mixins = [devices, featureToggling];

mixins.forEach((mixin) => Vue.mixin(mixin));
